module.exports = __webpack_public_path__ + "static/defaultPin-f69b28bf4b4ce65733aaf754555cf3d0.png";